<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    <h2>Dodaj plik</h2>
  </div>


  <div fxLayout="row" *ngIf="file?.uuid">
    <mat-form-field fxFlex="100" >
      <mat-label> Nazwa pliku </mat-label>
      <input [required]="true" name="fileName"  matInput placeholder="Nazwa pliku"   [formControl]="fileNameControl" >
      <mat-error *ngIf="fileForm.get('fileName').hasError('required')">To pole jest wymagane</mat-error>
      <mat-error></mat-error>
    </mat-form-field>
  </div>

  <div fxLayout="row"    fxFlex="100" >
    <app-dict-tag-file-manager [formControl]="tagControl" [multiple]="true" [required]="false" fxFlex="100" label="TAG"></app-dict-tag-file-manager>
  </div>

  <div fxLayout="row" *ngIf="!file">
    <h3>Plik</h3>
  </div>

  <div fxLayout="row" fxLayoutAlign="center" *ngIf="!file">
    <app-file-drag-and-drop fxFlex="100" [multiple]="true" [fileControl]="fileControl" [required]="true"   [maxSize]="maxSize"  [fileResults]="fileResults"></app-file-drag-and-drop>
  </div>

  <div fxLayout="row">
    <h3>Uprawnienia</h3>
  </div>

  <div fxLayout="row" fxFlex="100" *ngIf="(userPermissions | async).file_manager.admin_root ">
    <mat-slide-toggle color="accent" [formControl]="publicControl">Plik wewnętrzny</mat-slide-toggle>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" *ngIf="!publicControl.value">
    <div  fxFlex="50">
      <mat-slide-toggle [formControl]="permissionPartnerControl" >Partner</mat-slide-toggle>
    </div>
  </div>

  <div fxLayout="row"   fxFlex="100" *ngIf="permissionPartnerControl.value">
    <app-dict
      fxFlex="100"
      [label]="'Tagi Partnera'"
      [dictType]="'partner_tags'"
      [required]="false"
      [multiple]="true"
      [formControl]="permissionTagPartnerPartnerControl">

    </app-dict>
  </div>

  <div fxLayout="row"   fxFlex="100" *ngIf="permissionPartnerControl.value">
    <app-dict
      fxFlex="100"
      [label]="'Firma'"
      [dictType]="'company'"
      [required]="false"
      [multiple]="true"
      [formControl]="permissionCompanyPartnerPartnerControl">

    </app-dict>
  </div>

  <div fxLayout="row"    fxFlex="100"  *ngIf="permissionPartnerControl.value" >
    <app-dict-insurance-companies [formControl]="permissionRegistrationPartnerListControl"  [multiple]="true" [required]="false" fxFlex="100" label="Rejestracje"></app-dict-insurance-companies>
  </div>

  <div fxLayout="row" fxLayoutGap="15px"  *ngIf="!publicControl.value">
    <div  fxFlex="50">
      <mat-slide-toggle [formControl]="permissionOfwcaControl" >Ofwca</mat-slide-toggle>
    </div>
  </div>

  <div fxLayout="row"   fxFlex="100"  *ngIf="permissionOfwcaControl.value">
    <app-dict
      fxFlex="100"
      [label]="'Tagi Partnera'"
      [dictType]="'partner_tags'"
      [required]="false"
      [multiple]="true"
      [formControl]="permissionTagPartnerOfwcaControl">

    </app-dict>
  </div>

  <div fxLayout="row"   fxFlex="100" *ngIf="permissionOfwcaControl.value">
    <app-dict
      fxFlex="100"
      [label]="'Firma'"
      [dictType]="'company'"
      [required]="false"
      [multiple]="true"
      [formControl]="permissionCompanyPartnerOfwcaControl">

    </app-dict>
  </div>

  <div fxLayout="row"    fxFlex="100"  *ngIf="permissionOfwcaControl.value">
    <app-dict-insurance-companies [formControl]="permissionRegistrationOfwcaListControl"  [multiple]="true" [required]="false" fxFlex="100" label="Rejestracje"></app-dict-insurance-companies>
  </div>


  <div fxLayout="row" fxLayoutGap="15px"  *ngIf="!publicControl.value">
    <div  fxFlex="50">
      <mat-slide-toggle [formControl]="permissionUserControl" >Pracownik</mat-slide-toggle>
    </div>
  </div>

  <div fxLayout="row"   fxFlex="100"  *ngIf="permissionUserControl.value">
    <app-dict-users
      fxFlex="100"
      label="Użytkownik"
      [multiple]="true"
      [userFormsPermission]="true"
      [contentEditable]="true"
      [userPageSize] = 999
      [userPermissionsEditable]="false"
      [formControl]="permissionUserListControl"
      [userFilter]= "'ROLE_ASF360'"
      [role]="true"
    ></app-dict-users>
  </div>

  <div fxLayout="row"    fxFlex="100"  *ngIf="permissionUserControl.value">
    <app-dict-departments [formControl]="permissionDepartmentsUserListControl"  [multiple]="true" [required]="false" fxFlex="100" label="Dział"></app-dict-departments>
  </div>


  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button  mat-raised-button (click)="sendForm()" color="primary" [class.spinner]="processingRequest" [disabled]="processingRequest">Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
